<template>
	<img
		:src="`/img/flags/${iso}.svg`"
		:alt="iso"
		class="w-full"
		loading="lazy"
		>
</template>

<script setup lang="ts">
defineProps<{
	iso?: string
}>();
</script>
